import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RuinedForestTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RUINED_FOREST;
}

export default RuinedForestTerrainTileEntity;
